import React, { useState } from 'react';
import {Button, Menu} from 'antd';
import jsPDF from 'jspdf';
import bwipjs from 'bwip-js';
import { v4 as uuidv4 } from 'uuid'; // For generating UUIDs

const BarcodePDFGenerator = () => {
    const [loading, setLoading] = useState(false);

    const generatePDF = async () => {
        setLoading(true); // Start loading

        const doc = new jsPDF({
            orientation: 'p',
            unit: 'mm',
            format: 'letter' // Set to US letter size
        });

        const numCols = 2;  // Two columns
        const numRows = 11;  // Adjusted to 11 rows
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        // Adjusted barcode dimensions to fit more rows
        const barcodeWidth = 50; // Scaled down width of each barcode
        const barcodeHeight = 15; // Scaled down height of each barcode
        const horizontalSpacing = (pageWidth - (numCols * barcodeWidth)) / (numCols + 1); // Evenly space columns across the width
        const verticalSpacing = (pageHeight - (numRows * barcodeHeight)) / (numRows + 1); // Evenly space rows down the height

        for (let row = 0; row < numRows; row++) {
            for (let col = 0; col < numCols; col++) {
                const xStart = horizontalSpacing + col * (barcodeWidth + horizontalSpacing); // Calculate starting X based on spacing
                const yStart = verticalSpacing + row * (barcodeHeight + verticalSpacing); // Calculate starting Y based on spacing

                const canvas = document.createElement('canvas');
                const uuid = uuidv4(); // Generate a new UUID for each barcode
                try {
                    bwipjs.toCanvas(canvas, {
                        bcid: 'pdf417',       // Barcode type
                        text: uuid,           // Text to encode
                        scale: 2,             // Adjusted scaling factor to fit smaller size
                        height: barcodeHeight,  // Bar height, in millimeters
                        includetext: true,    // Include text below barcode
                        textxalign: 'center', // Always good to set this
                    });

                    // Draw the barcode on the PDF
                    doc.addImage(canvas.toDataURL('image/png'), 'PNG', xStart, yStart, barcodeWidth, barcodeHeight);
                } catch (err) {
                    console.error('Error generating barcode:', err);
                }
            }
        }

        // Save the created PDF and trigger print
        doc.save('output.pdf');
        window.open(doc.output('bloburl'), '_blank');
        setLoading(false); // End loading
    };

    return (
        <Button type="primary" onClick={generatePDF} loading={loading}>
            Generate Entry Slips
        </Button>
    );
};

export default BarcodePDFGenerator;
